import { render } from "./ChooseStore.vue?vue&type=template&id=ed98c89c&scoped=true"
import script from "./ChooseStore.vue?vue&type=script&lang=js"
export * from "./ChooseStore.vue?vue&type=script&lang=js"

import "./ChooseStore.vue?vue&type=style&index=0&id=ed98c89c&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed98c89c"]])

export default __exports__